import React from 'react';

const SecurityInfoSection = () => {
  return (
    <div className="security-info-section">
      <div className="security-copy">
        <div className="security-info-title">Sécurité des connexions exchange</div>
        <div className="security-text">Vos clés API sont chiffrées et utilisées uniquement en lecture.</div>
      </div>
      <span className="security-badge">Lecture seule activée</span>
    </div>
  );
};

export default SecurityInfoSection;
